import { SliderConfig } from "../types/sliderConfig";

export const sliderConfigs: SliderConfig<"shame" | "risk" | "effects">[] = [
  { key: "shame", label: "Shame Level", min: 0, max: 5 },
  { key: "risk", label: "Risk Level", min: 0, max: 5 },
  { key: "effects", label: "Long-term Effects", min: 0, max: 5 },
];
